var exports = {
  "u": "MergeQueueSectionText__AOjxda",
};

module.exports = exports;
